import type { ReactElement } from 'react';
import { Ccontainer } from '../Ccontainer';
import { ChackerheaderAnimatedText } from './ChackerheaderAnimatedText';
import { ChackerheaderBracket } from './ChackerheaderBracket';
import type { ChackerheaderTextVisualProps } from './ChackerheaderTypes';

interface ChackerheaderViewProps extends ChackerheaderTextVisualProps {
  displayText: string;
  gap: number | string;
  isAnimating: boolean;
}

export function ChackerheaderView({
  displayText,
  fontSize,
  fontWeight,
  gap,
  isAnimating,
  opacity,
  textColor,
}: ChackerheaderViewProps): ReactElement {
  return (
    <Ccontainer
      alignItems="center"
      justifyContent="center"
      gap={gap}
      padding={0}
    >
      <ChackerheaderBracket
        bracket="["
        fontSize={fontSize}
        fontWeight={fontWeight}
        opacity={opacity}
        textColor={textColor}
      />
      <ChackerheaderAnimatedText
        displayText={displayText}
        fontSize={fontSize}
        fontWeight={fontWeight}
        isAnimating={isAnimating}
        opacity={opacity}
        textColor={textColor}
      />
      <ChackerheaderBracket
        bracket="]"
        fontSize={fontSize}
        fontWeight={fontWeight}
        opacity={opacity}
        textColor={textColor}
      />
    </Ccontainer>
  );
}
